<template>
  <el-select
    v-model="batchIndex"
    :placeholder="$t('batchIndex.selectPlaceholder')"
    collapse-tags
    clearable
    multiple
    @change="filterSubclusterInstances"
    class="batchIndex_cls"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value"
      :disabled="item.value > dayTime"
    >
    </el-option>
  </el-select>
</template>

<script>
import { postRequest } from '@/common/libs/request';
import dayjs from 'dayjs';

export default {
  name: 'batchIndex',
  data() {
    return {
      batchIndex: [],  // 当前选中的批次索引数组
      options: [],     // 下拉选项数据
      dayTime: dayjs().valueOf(),  // 当前时间戳
    };
  },
  props: {
    subclusterIds: {
      type: Number,
      default: null,
    },
    batchListData: {
      default: null,
    },
    dialogBatchListData: {
      default: null,
    },
  },
  watch: {
    batchListData(newV) {
      this.getAllSubclusterActivityCreateBatchIndex(newV);
    },
    dialogBatchListData(newV) {
      this.getAllSubclusterActivityCreateBatchIndex(newV);
    },
  },
  methods: {
    /**
     * 重置批次选择器
     * 清空当前选中的批次索引数组
     */
    resetBatchIndex() {
      this.batchIndex = [];
    },

    /**
     * 过滤子集群实例
     * 触发父组件的filterSubclusterInstances事件
     * 传递当前选中的批次索引数组
     */
    filterSubclusterInstances() {
      this.$emit('filterSubclusterInstances', this.batchIndex);
    },

    /**
     * 获取子集群实例列表
     * @param {Number} id - 子集群ID
     * 1. 清空当前选中的批次索引和选项数据
     * 2. 请求获取子集群实例列表
     * 3. 处理返回数据并更新批次选项
     */
    getSubclusterInstances(id) {
      const data = {
        subclusterId: id,
      };
      this.batchIndex = [];
      this.options = [];
      postRequest('/api/eda/common/subcluster/getSubclusterInstancesOnline', data).then((res) => {
        this.getAllSubclusterActivityCreateBatchIndex(res);
      });
    },

    /**
     * 获取所有子集群活动创建的批次索引
     * @param {Object} dataInfo - 包含子集群实例列表和最大批次索引的数据对象
     * 1. 初始化批次选项数组
     * 2. 统计每个批次的实例数量
     * 3. 更新下拉选项数据
     */
    getAllSubclusterActivityCreateBatchIndex(dataInfo) {
      const countMaps = [];
      const dataList = dataInfo.subclusterInstanceList;

      // 初始化批次选项
      for (let i = 0; i < dataInfo.maxBatchIndex; i++) {
        countMaps.push({
          label: `${i + 1} ${this.$t('batchIndex.totalCount', { count: 0 })}`,
          value: this.dayTime + i + 2
        });
      }

      this.options = [];
      const list = (dataList || []).map(item => item.createBatchIndex);
      const countMap = {};

      // 统计每个批次的实例数量
      for (let i = 0; i < list.length; i++) {
        const num = list[i];
        countMap[num] = countMap[num] ? countMap[num] + 1 : 1;
      }

      // 更新批次选项
      // eslint-disable-next-line no-return-assign
      Object.entries(countMap).map(([label, value]) => (
        countMaps[label - 1] = {
          label: `${label} ${this.$t('batchIndex.totalCount', { count: value })}`,
          value: label,
        }
      ));

      this.options = countMaps;
    },
  },
};
</script>

<style lang="scss" scoped>
.batchIndex_cls {
  width: 150px !important;
  margin-right: 10px;
  ::v-deep .el-input {
    width: 150px !important;
  }
}
</style>
